export default {
  bp_xs: "(min-width: 400px)",
  bp_sm: "(min-width: 768px)",
  bp_md: "(min-width: 992px)",
  bp_lg: "(min-width: 1024px)",
  bp_xl: "(min-width: 1200px)",
}
